var mailChimpAjax = {
    render: function(){
        $('.newsletter__form').each(function(){
            var $form = $(this);
            var $formBtn = $form.find('.newsletter__form-btn');
            var $formMessage = $form.parent().find('.newsletter__message');
            var $formInput = $form.find('.newsletter__form-wrapper .newsletter__form-input');

            if ( $form.length > 0 ) {
                $formBtn.bind('click', function ( event ) {
                    event.preventDefault();

                    register($form);
                });
            }

            function register($form) {
                $formMessage.find('span').html('Sending...');
                
                $.ajax({
                    type: $form.attr('method'),
                    url: $form.attr('action'),
                    data: $form.serialize(),
                    cache: false,
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    error: function(err) { 
                        alert('Could not connect to the registration server. Please try again later.') 
                    },
                    success: function(data) {
                        if (data.result === 'success') {
                            // console.log(data.msg);

                            $formMessage.addClass('newsletter__message--active newsletter__message--success');
                            $formInput.val('');
                            $formMessage.find('span').html(data.msg);
                        } else {
                            // console.log(data.msg);

                            $formMessage.removeClass('newsletter__message--success');
                            $formMessage.addClass('newsletter__message--active');

                            if(data.msg.indexOf('0') === 0){
                                $formMessage.find('span').html(data.msg.slice(3));
                            } else{
                                $formMessage.find('span').html(data.msg);
                            }
                        }
                    }
                })
            };
        });
    },
    init: function(){
        this.render();
    }
};

mailChimpAjax.init();